const API_URL = process.env.REACT_APP_API_URL || "https://api.adolphefrantzley.best/api";

const getHeaders = () => {
  const token = localStorage.getItem("adminToken");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const loginAdmin = async (credentials) => {
  const res = await fetch(`${API_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(credentials),
  });
  if (!res.ok) throw new Error("Invalid credentials");
  return res.json();
};

export const fetchProjects = async () => {
  const res = await fetch(`${API_URL}/projects`);
  if (!res.ok) throw new Error("Failed to fetch projects");
  return res.json();
};

export const createProject = async (projectData) => {
  // If projectData is FormData, don't set Content-Type header so the browser sets it automatically with the boundary
  const isFormData = projectData instanceof FormData;
  const token = localStorage.getItem("adminToken");

  const headers = {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  if (!isFormData) headers["Content-Type"] = "application/json";

  const res = await fetch(`${API_URL}/projects`, {
    method: "POST",
    headers,
    body: isFormData ? projectData : JSON.stringify(projectData),
  });
  if (!res.ok) throw new Error("Failed to create project");
  return res.json();
};

export const updateProject = async (id, projectData) => {
  const isFormData = projectData instanceof FormData;
  const token = localStorage.getItem("adminToken");

  const headers = {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  if (!isFormData) headers["Content-Type"] = "application/json";

  const res = await fetch(`${API_URL}/projects/${id}`, {
    method: "PUT",
    headers,
    body: isFormData ? projectData : JSON.stringify(projectData),
  });
  if (!res.ok) throw new Error("Failed to update project");
  return res.json();
};

export const deleteProject = async (id) => {
  const res = await fetch(`${API_URL}/projects/${id}`, {
    method: "DELETE",
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Failed to delete project");
  return res.json();
};

export const reorderProjects = async (orderings) => {
  const res = await fetch(`${API_URL}/projects/reorder`, {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify({ orderings }),
  });
  if (!res.ok) throw new Error("Failed to update project order");
  return res.json();
};

// BLOG POSTS
export const fetchPosts = async (admin = false) => {
  const url = admin ? `${API_URL}/posts?admin=true` : `${API_URL}/posts`;
  const res = await fetch(url, {
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Failed to fetch posts");
  return res.json();
};

export const fetchPostBySlug = async (slug) => {
  const res = await fetch(`${API_URL}/posts/${slug}`, {
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Failed to fetch post");
  return res.json();
};

export const createPost = async (formData) => {
  const res = await fetch(`${API_URL}/posts`, {
    method: "POST",
    headers: { "Authorization": `Bearer ${localStorage.getItem("adminToken")}` },
    body: formData,
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.details || errorData.error || "Failed to create post");
  }
  return res.json();
};

export const updatePost = async (id, formData) => {
  const res = await fetch(`${API_URL}/posts/${id}`, {
    method: "PUT",
    headers: { "Authorization": `Bearer ${localStorage.getItem("adminToken")}` },
    body: formData,
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.details || errorData.error || "Failed to update post");
  }
  return res.json();
};

export const deletePost = async (id) => {
  const res = await fetch(`${API_URL}/posts/${id}`, {
    method: "DELETE",
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Failed to delete post");
  return res.json();
};

export const addComment = async (slug, commentData) => {
  const res = await fetch(`${API_URL}/posts/${slug}/comments`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(commentData),
  });
  if (!res.ok) throw new Error("Failed to add comment");
  return res.json();
};

export const deleteComment = async (id) => {
  const res = await fetch(`${API_URL}/comments/${id}`, {
    method: "DELETE",
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Failed to delete comment");
  return res.json();
};

export const uploadBlogImage = async (formData) => {
  const res = await fetch(`${API_URL}/posts/upload-image`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: formData,
  });
  if (!res.ok) throw new Error("Failed to upload image");
  return res.json();
};

export const fetchMessages = async () => {
  const res = await fetch(`${API_URL}/contact`, {
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Failed to fetch messages");
  return res.json();
};

export const sendMessage = async (messageData) => {
  const res = await fetch(`${API_URL}/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(messageData),
  });
  if (!res.ok) throw new Error("Failed to send message");
  return res.json();
};

export const subscribeToNewsletter = async (email) => {
  const res = await fetch(`${API_URL}/newsletter/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || "Failed to subscribe");
  }
  return res.json();
};
